<template>
  <div class="noData">
    <img src="/img/bigdata/no-data.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
  export default {
    name: "noData",
    components: {},
    data() {
      return {}
    },
    methods: {},
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .noData {
    text-align: center;
    color: #B8D7FF;
    p{
      margin-top: 10px;
    }
  }
</style>
